// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3H9hd","file":"styles_file__1iKgo"};